export class SecurityScanConclusionCondition {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "operator",
            "baseName": "operator",
            "type": "ListOperators",
            "format": ""
        },
        {
            "name": "securityScanConclusions",
            "baseName": "securityScanConclusions",
            "type": "Array<SecurityScanConclusion>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SecurityScanConclusionCondition.attributeTypeMap;
    }
    constructor() {
    }
}
